import { render, staticRenderFns } from "./countriesDetection.vue?vue&type=template&id=4bd75b94&scoped=true&"
import script from "./countriesDetection.vue?vue&type=script&lang=js&"
export * from "./countriesDetection.vue?vue&type=script&lang=js&"
import style0 from "./countriesDetection.vue?vue&type=style&index=0&id=4bd75b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd75b94",
  null
  
)

export default component.exports